export const enum AppVersion {
  v1 = 'v1'
}

